import { defineComponent as _defineComponent } from 'vue'
import { authModule } from '../store'
import { UserRole } from '../../common/types/Irmao'
import { Fragment } from 'vue-fragment'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentAuthGuard',
  props: {
    requires: { type: [Array, Boolean], default: () => [] }
  },
  setup(__props: any) {

const props = __props as { requires: UserRole[] | boolean };



const hasAuthorization = computed(() => {
  return typeof props.requires === 'boolean'
    ? props.requires
    : authModule.hasAuthorization(props.requires)
})

return { __sfc: true,props, hasAuthorization, Fragment }
}

})